import {Injectable} from '@angular/core';
import {AppSettings} from '../helpers/app-settings';
import {AuthService} from '../auth/auth.service';
import {addSeconds} from 'date-fns';
import {DoctorService} from '../api/doctor/doctor.service';
import {PatientsService} from '../api/patients/patients.service';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IdleCheckerService {

  private eventHandler;
  private interval;
  private timeoutTracker;
  private timeout;
  private inactive = false;

  constructor(private appSetting: AppSettings, private authService: AuthService,
              private doctorService: DoctorService, private patientService: PatientsService) {

  }

  public startPinging(): void {

    this.eventHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.startInterval();

  }

  public sendPingEvery(timeout): void {
    this.timeout = timeout;
  }

  startInterval(): void {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      this.sendPing();
    }, 10000);
  }

  updateExpiredTime(): void {

    this.inactive = false;

    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }

    // Despues de 3 minutos de inactividad se le pone como inactive
    this.timeoutTracker = setTimeout(() => {
      this.inactive = true;
    }, 3 * 60000);

  }

  tracker(): void {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }

  cleanUp(): void {
    clearInterval(this.interval);
    window.removeEventListener('mousemove', this.eventHandler);
    window.removeEventListener('scroll', this.eventHandler);
    window.removeEventListener('keydown', this.eventHandler);
  }

  /**
   * Enviar ping de actividad cada tanto
   * @private
   */
  private sendPing(): void {

    // console.log('logica de enviar ping. Inactive: ', this.inactive);


    if (!this.inactive) {

      const lastSentPingRecovered = parseInt(this.appSetting.get('last_activity_pn'), 10);

      const lastSentPing = isNaN(lastSentPingRecovered) ? undefined : lastSentPingRecovered;

      if (lastSentPing === undefined ||
        addSeconds(new Date(lastSentPing), this.timeout).getTime() <= Date.now()) {

        // Send Ping.
        let pingSubscription: Observable<void>;
        if (this.authService.panelType === 'doctor') {
          pingSubscription = this.doctorService.pingActivity();
        } else {
          pingSubscription = this.patientService.pingActivity();
        }

        pingSubscription.pipe(first()).subscribe();

        this.appSetting.set('last_activity_pn', Date.now().toString());

      }
    }


  }

}
